import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { SpeakerLabelOverride } from './buildSpeakerLabelOverrides';

type TParams = {
  openModal: (modalName: keyof typeof ModalNamesEnum, modalProps?: object) => void;
  closeModal: () => void;
  hasVersions: boolean;
  speakerLabels: string[];
  submit: (speakerLabelOverrides?: SpeakerLabelOverride[]) => void | Promise<void>;
};

export async function openCloudLayoutRegenerationFlow({
  openModal,
  closeModal,
  hasVersions,
  speakerLabels,
  submit,
}: TParams) {
  if (!hasVersions) {
    try {
      await submit();
    } catch {
      return;
    }

    return;
  }

  openModal(ModalNamesEnum.RegenerateWithLayout, {
    speakerLabels,
    onContinue: (speakerLabelOverrides?: SpeakerLabelOverride[]) => {
      openModal(ModalNamesEnum.ConfirmCloudLayoutReset, {
        onSuccess: async () => {
          await submit(speakerLabelOverrides);
          closeModal();
        },
      });
    },
  });
}
